"use client"

import { clx } from "@medusajs/ui"
import { Loader } from "@medusajs/icons"
import React from "react"
import { useFormStatus } from "react-dom"

export function SubmitButton({
  children,
  variant = "primary",
  className,
  "data-testid": dataTestId,
}: {
  children: React.ReactNode
  variant?: "primary" | "secondary" | "transparent" | "danger" | null
  className?: string
  "data-testid"?: string
}) {
  const { pending } = useFormStatus()

  const look =
    variant === "secondary" || variant === "transparent"
      ? "btn-ghost"
      : "btn-clay"

  return (
    <button
      type="submit"
      disabled={pending}
      className={clx(look, className)}
      data-testid={dataTestId}
    >
      {pending && <Loader className="animate-spin" />}
      {children}
    </button>
  )
}
